import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

const PLACEHOLDER = '{{1}}'

/**
 * O template da Meta foi salvo com {{1}} digitado na URL.
 * O clique chega em /campanha/{{1}}{slug}/perfil e precisa ir para /campanha/{slug}/perfil.
 */
export function CampaignWhatsAppSlugRedirect() {
  const { slug = '' } = useParams()
  const location = useLocation()
  const fixedSlug = slugWithoutWhatsAppPlaceholder(slug)

  if (fixedSlug === null) {
    return <Outlet />
  }

  const tail = location.pathname.replace(/^\/campanha\/[^/]+/, '')

  return (
    <Navigate
      to={{ pathname: `/campanha/${fixedSlug}${tail}`, search: location.search, hash: location.hash }}
      replace
    />
  )
}

export function slugWithoutWhatsAppPlaceholder(slug: string): string | null {
  let decoded = slug
  try {
    decoded = decodeURIComponent(slug)
  } catch {
    decoded = slug
  }

  if (!decoded.startsWith(PLACEHOLDER)) {
    return null
  }

  const fixed = decoded.slice(PLACEHOLDER.length)
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(fixed)) {
    return null
  }

  return fixed
}
